/**
 * Enum for the different project actions.
 */
enum ProjectAction {
  Rename = 'rename',
  Delete = 'delete',
  Download = 'download',
}

export default ProjectAction;
